import { css, defineConfig, TwindConfig } from "@twind/core";
import tailwind from "@twind/preset-tailwind";
import autoprefix from "@twind/preset-autoprefix";
import presetLineClamp from "@twind/preset-line-clamp";

addEventListener("warning", (event) => {
  // prevent default console.warn(`[<code>] <message>: <detail>`) logging
  event.preventDefault();
});

// @ts-ignore
export const config: TwindConfig = defineConfig({
  presets: [tailwind(), autoprefix(), presetLineClamp()],
  preflight: [
    () => css`
      html,
      body {
        font-size: clamp(16px, 2vw, 20px);
        font-family: "Geist", ui-sans-serif, system-ui, sans-serif;
        @apply bg-neutral-900 text-white;
      }

      html {
        overflow: hidden;
        width: 100%;
      }

      body {
        width: 100%;
        height: 100%;
        position: fixed;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
      }

      *:not(head, script, style, link) {
        @apply min-w-0;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
      }

      ::-webkit-scrollbar {
        display: none;
      }

      textarea {
        field-sizing: content;
      }

      input[type="time"] {
        postion: relative;
        margin: 0;
        padding: 0;
        text-align: center;
        font-variant: tabular-nums;
      }

      input[type="time"]::-webkit-calendar-picker-indicator {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        margin: 0;
        padding: 0;
      }
    `,
  ],
  theme: {
    extend: {
      fontFamily: {
        sans: ["Geist", "ui-sans-serif", "system-ui", "sans-serif"],
        pacifico: ["Pacifico", "cursive"],
      },
      screens: {
        xs: "540px",
      },
    },
  },

  rules: [
    [
      "aspect-",
      "aspectRatio",
      ({ $$ }: { $$: string }) => `${$$.replace("-", " / ")}`,
    ],
    ["col", { display: "flex", flexDirection: "column" }],
    ["row", { display: "flex", flexDirection: "row" }],
    ["no-scrollbars", { scrollbarWidth: "none" }],
    ["overflow-scrolling-touch", { WebkitOverflowScrolling: "touch" }],
    ["aic", { alignItems: "center" }],
    ["aifs", { alignItems: "flex-start" }],
    ["aife", { alignItems: "flex-end" }],
    ["aib", { alignItems: "baseline" }],
    ["jcfs", { justifyContent: "flex-start" }],
    ["jcc", { justifyContent: "center" }],
    ["jcfe", { justifyContent: "flex-end" }],
    ["jcsa", { justifyContent: "space-around" }],
    ["jcsb", { justifyContent: "space-between" }],
    ["text-balance", { textWrap: "balance" }],
    [
      "ms-(\\d+)",
      (match: any) => ({ "margin-inline-start": `${match[1] / 4}rem` }),
    ],
    [
      "me-(\\d+)",
      (match: any) => ({ "margin-inline-end": `${match[1] / 4}rem` }),
    ],
    [
      "ps-(\\d+)",
      (match: any) => ({ "padding-inline-start": `${match[1] / 4}rem` }),
    ],
    [
      "pe-(\\d+)",
      (match: any) => ({ "padding-inline-end": `${match[1] / 4}rem` }),
    ],
    ["ltr", { direction: "ltr" }],
    ["rtl", { direction: "rtl" }],
    ["text-pretty", { textWrap: "pretty" }],
    ["text-balance", { textWrap: "balance" }],
  ],
  variants: [["children", "&>*"]],
});
